/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds.
 * see: https://chrisboakes.com/how-a-javascript-debounce-function-works/
 * @param {fn} callback
 * @param {number} wait
 */
function debounce(callback, wait) {
  let timeout
  let context
  let args

  function debounced() {
    context = this
    args = arguments

    clearTimeout(timeout)
    timeout = setTimeout(() => callback.apply(context, args), wait)
  }

  // cancel debounce and invoke immediately
  function flush() {
    clearTimeout(timeout)
    callback.apply(context, args)
  }

  debounced.flush = flush

  return debounced
}

export default debounce
